import debounce from "debounce"

export default function initBodyScrollStatus() {
  const bodyElement = document.querySelector("body")
  let topThreshold = 0
  let bottomThreshold = 0

  const statusClasses = {
    top: "--scrolled-top",
    scrolling: "--scrolling",
    bottom: "--scrolled-bottom",
  }
  let lastStatus = null

  const updateStatus = (selectedClass) => {
    if (selectedClass !== lastStatus) {
      Object.keys(statusClasses).forEach((key) => {
        let statusClass = statusClasses[key]

        if (selectedClass === statusClass) {
          bodyElement.classList.add(statusClass)
        } else {
          bodyElement.classList.remove(statusClass)
        }
      })

      lastStatus = selectedClass
    }
  }

  const updateBodyHeight = () => {
    topThreshold = window.innerHeight * 0.05
    bottomThreshold = bodyElement.getBoundingClientRect().height - window.innerHeight * 1.05
  }

  const handler = () => {
    if (window.scrollY <= topThreshold) {
      updateStatus(statusClasses.top)
    } else if (window.scrollY >= bottomThreshold) {
      updateStatus(statusClasses.bottom)
    } else {
      updateStatus(statusClasses.scrolling)
    }
  }

  updateBodyHeight()
  handler()

  window.addEventListener(
    "resize",
    debounce(() => {
      updateBodyHeight()
      handler()
    }, 50)
  )

  window.addEventListener(
    "lazyloaded",
    debounce(() => {
      updateBodyHeight()
      handler()
    }, 50)
  )

  window.addEventListener(
    "scroll",
    debounce(() => {
      handler()
    }, 10),
    { passive: true }
  )
}
